//
//
//
//
//
//
//
//

import titleBox from '@/components/titlebox.vue';
export default {
  components: {
    titleBox
  },
  name: 'lists',
  data() {
    return {};
  },
  methods: {
    // ...mapActions()
  },
  watch: {},
  computed: {
    // ...mapGetters()
  },
  created() {},
  mounted() {}
};
